export default {
  informations: {},
  companies: [],
  agency: null
}
